import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { ValidatorForm } from "react-material-ui-form-validator";
import axios from "../../../../axios-order";
import MonthDatePicker from "../../../../components/ui/monthWiseDatePicker";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import Modal from "react-bootstrap/Modal";

const C = {
    navy: "#1a3f6f",
    accent: "#1a6fc4",
    accentLight: "#e8f1fb",
    white: "#ffffff",
    surface: "#f7f9fc",
    border: "#dde3ec",
    borderLight: "#eef1f6",
    text: "#1a3f6f",
    textSub: "#4a6080",
    textMuted: "#8298b2",
    books: { bg: "#fef7e6", text: "#7a4e00", border: "#f5d98a" },
    gstr: { bg: "#e8f1fb", text: "#1a4a8a", border: "#aac9ef" },
    success: { bg: "#edf8f1", text: "#1a6e3e", dot: "#28a55f" },
};

const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

function formatPeriod(period) {
    if (!period) return "—";
    const mm = parseInt(period.slice(0, 2)) - 1;
    const yy = period.slice(2);
    return `${monthNames[mm]} ${yy}`;
}

function formatDateTime(dt) {
    if (!dt) return "—";
    const [date, time] = dt.replace("Z", "").split("T");
    return (
        <span>
            <span style={{ color: C.text, fontWeight: "500" }}>{date}</span>
            <span style={{ color: C.textMuted }}> · {time}</span>
        </span>
    );
}

const DocIcon = () => (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={C.accent} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
        <polyline points="14 2 14 8 20 8" />
        <line x1="9" y1="13" x2="15" y2="13" />
        <line x1="9" y1="17" x2="13" y2="17" />
    </svg>
);

export default function ItcAvailReport() {
    const [handleFromDate, setHandleFromDate] = useState("");
    const [handleToDate, setHandleToDate] = useState("");
    const [handleFromDateToDisplay, setHandleFromDateToDisplay] = useState(null);
    const [handleToDateToDisplay, setHandleToDateToDisplay] = useState(null);
    const [tdsReconHistoryData, setTdsReconHistoryData] = useState([]);
    const [loaderForTable, setLoaderForTable] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [selectedReportType, setSelectedReportType] = useState("");
    const [activeFilter, setActiveFilter] = useState("all");
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarSeverity, setSnackbarSeverity] = useState("success");
    const [responseMessage, setResponseMessage] = useState("");
    const [hoveredRow, setHoveredRow] = useState(null);

    const history = useHistory();

    const handleSnackbarOpen = (message, severity) => {
        setSnackbarOpen(true);
        setSnackbarSeverity(severity);
        setResponseMessage(message);
    };

    const handleSnackbarClose = () => {
        setSnackbarOpen(false);
        setResponseMessage("");
    };

    const getTdsPayableRecon = () => {
        setLoaderForTable(true);
        axios
            .post("/get_itc_report_records", {
                business_entity_id: localStorage.getItem("business_entity_id"),
            })
            .then((res) => {
                setLoaderForTable(false);
                setTdsReconHistoryData(res.data.records || []);
            })
            .catch(() => setLoaderForTable(false));
    };

    useEffect(() => { getTdsPayableRecon(); }, []);

    const functionToHandleFromDate = (v) => {
        const mm = (v.getMonth() + 1).toString().padStart(2, "0");
        setHandleFromDate(`${mm}${v.getFullYear()}`);
        setHandleFromDateToDisplay(v);
    };

    const functionToHandleToDate = (v) => {
        const mm = (v.getMonth() + 1).toString().padStart(2, "0");
        setHandleToDate(`${mm}${v.getFullYear()}`);
        setHandleToDateToDisplay(v);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setHandleFromDateToDisplay(null);
        setHandleToDateToDisplay(null);
        setHandleFromDate("");
        setHandleToDate("");
        setSelectedReportType("");
    };

    const onSubmitHandlerForData = () => {
        if (!selectedReportType) {
            handleSnackbarOpen("Please select a Report Type", "error");
            return;
        }
        axios
            .post("create_itc_report_summary", {
                business_entity_id: localStorage.getItem("business_entity_id"),
                start_period: handleFromDate,
                end_period: handleToDate,
                report_type: selectedReportType,
                org_gstin: localStorage.getItem("gst"),
            })
            .then((res) => {
                handleSnackbarOpen(res.data.message, res.data.status ? "success" : "error");
                getTdsPayableRecon();
                handleCloseModal();
            })
            .catch(() => { getTdsPayableRecon(); handleCloseModal(); });
    };

    const updatedShowDetails = (item) => {
        history.push({ pathname: `/itcAvailReport/${item.recon_id}`, state: { items: item } });
    };

    const booksCount = tdsReconHistoryData.filter(r => r.report_type === "books").length;
    const gstrCount = tdsReconHistoryData.filter(r => r.report_type === "gstr_2b").length;

    const filteredData = tdsReconHistoryData.filter((item) =>
        activeFilter === "all" ||
        (activeFilter === "books" && item.report_type === "books") ||
        (activeFilter === "gstr" && item.report_type === "gstr_2b")
    );

    const thStyle = { padding: "11px 18px", textAlign: "left", fontSize: "11px", fontWeight: "600", letterSpacing: "0.05em", color: "#ffffff", background: C.navy, borderBottom: "1px solid #16355c", textTransform: "uppercase", whiteSpace: "nowrap" };
    const tdStyle = { padding: "8px 18px", fontSize: "13px", color: C.text, borderBottom: `1px solid ${C.borderLight}` };
    const renderTableBody = () => {
        if (loaderForTable) {
            return Array.from({ length: 3 }).map((_, i) => (
                <tr key={i}>
                    {[60, 40, 20, 20, 10].map((w, j) => (
                        <td key={j} style={tdStyle}>
                            <div style={{ height: "14px", borderRadius: "4px", background: C.borderLight, width: `${w}%`, animation: "pulse 1.4s ease-in-out infinite" }} />
                        </td>
                    ))}
                </tr>
            ));
        }
        if (!filteredData.length) {
            return (
                <tr>
                    <td colSpan={5} style={{ ...tdStyle, textAlign: "center", padding: "52px 20px" }}>
                        <div style={{ fontSize: "28px", marginBottom: "10px", opacity: 0.4 }}>📄</div>
                        <div style={{ fontWeight: "500", marginBottom: "4px", color: C.textSub }}>No reports found</div>
                        <div style={{ fontSize: "12px", color: C.textMuted }}>
                            Generate your first ITC report to get started.
                        </div>
                    </td>
                </tr>
            );
        }
        return filteredData.map((item, i) => (
            <tr
                key={i}
                onMouseEnter={() => setHoveredRow(i)}
                onMouseLeave={() => setHoveredRow(null)}
                style={{ background: hoveredRow === i ? C.surface : C.white, transition: "background 0.1s" }}
            >
                <td style={tdStyle}>
                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                        <span style={{ fontWeight: "600" }}>{formatPeriod(item.from_tax_period)}</span>
                        <span style={{ fontSize: "10px", color: C.textMuted }}>→</span>
                        <span style={{ fontWeight: "600" }}>{formatPeriod(item.to_tax_period)}</span>
                    </div>
                </td>
                <td style={tdStyle}>
                    <span style={{ fontSize: "12px", color: C.textMuted, fontVariantNumeric: "tabular-nums" }}>
                        {formatDateTime(item.run_date_time)}
                    </span>
                </td>
                <td style={tdStyle}>
                    {item.report_type === "books"
                        ? <span style={{ display: "inline-block", padding: "3px 10px", borderRadius: "5px", fontSize: "11px", fontWeight: "600", background: C.books.bg, color: C.books.text, border: `1px solid ${C.books.border}` }}>Books</span>
                        : <span style={{ display: "inline-block", padding: "3px 10px", borderRadius: "5px", fontSize: "11px", fontWeight: "600", background: C.gstr.bg, color: C.gstr.text, border: `1px solid ${C.gstr.border}` }}>GSTR-2B</span>
                    }
                </td>
                <td style={tdStyle}>
                    <span style={{ display: "inline-flex", alignItems: "center", gap: "5px", padding: "3px 10px", borderRadius: "5px", fontSize: "11px", fontWeight: "600", background: C.success.bg, color: C.success.text }}>
                        <span style={{ width: "6px", height: "6px", borderRadius: "50%", background: C.success.dot, flexShrink: 0 }} />
                        {item.report_status || "Generated"}
                    </span>
                </td>
                <td style={{ ...tdStyle, textAlign: "center" }}>
                    <button
                        onClick={() => updatedShowDetails(item)}
                        style={{ padding: "5px 14px", borderRadius: "6px", whiteSpace: "nowrap", border: `1px solid ${hoveredRow === i ? C.accent : C.border}`, background: hoveredRow === i ? C.accentLight : C.white, color: hoveredRow === i ? C.accent : C.textSub, fontSize: "12px", fontWeight: "500", cursor: "pointer", transition: "all 0.15s" }}
                    >
                        View report →
                    </button>
                </td>
            </tr>
        ));
    };

    return (
        <React.Fragment>
            <style>{`@keyframes pulse { 0%,100%{opacity:1} 50%{opacity:0.4} }`}</style>

            <div style={{ padding: "28px 32px", background: C.surface}}>

                {/* Page header */}
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", background: C.white, border: `1px solid ${C.border}`, borderRadius: "10px", padding: "16px 20px", marginBottom: "20px", boxShadow: "0 1px 3px rgba(13,33,55,0.06)" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: "14px" }}>
                        <button
                            onClick={() => history.push("/reportCards")}
                            title="Back to Reports"
                            style={{ width: "32px", height: "32px", borderRadius: "8px", border: `1px solid ${C.border}`, background: C.white, display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", color: C.textSub, fontSize: "14px", flexShrink: 0 }}
                        >←</button>
                        <div style={{ width: "42px", height: "42px", borderRadius: "10px", background: C.accentLight, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                            <DocIcon />
                        </div>
                        <div>
                            <div style={{ fontSize: "23px", fontWeight: "700", color: C.text, lineHeight: 1.2 }}>ITC Avail Report</div>
                            <div style={{ fontSize: "12px", color: C.textMuted, marginTop: "4px" }}>Input tax credit availability records</div>
                        </div>
                    </div>
                    <button
                        onClick={() => setShowModal(true)}
                        style={{ display: "flex", alignItems: "center", gap: "6px", padding: "0 18px", height: "36px", borderRadius: "8px", background: C.navy, color: C.white, border: "none", fontSize: "13px", fontWeight: "500", cursor: "pointer" }}
                    >
                        <span style={{ fontSize: "16px", lineHeight: 1 }}>+</span>
                        New ITC Report
                    </button>
                </div>

                {/* Metrics */}
                {/* <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: "14px", marginBottom: "20px" }}>
                    {[
                        { label: "Total Reports", value: tdsReconHistoryData.length, borderColor: C.accent, badge: tdsReconHistoryData.length > 0 },
                        { label: "Books", value: booksCount, borderColor: "#e8a020", badge: false },
                        { label: "GSTR-2B", value: gstrCount, borderColor: C.accent, badge: false },
                    ].map(({ label, value, borderColor, badge }) => (
                        <div key={label} style={{ background: C.white, border: `1px solid ${C.border}`, borderRadius: "10px", padding: "16px 20px", boxShadow: "0 1px 3px rgba(13,33,55,0.05)", borderTop: `3px solid ${borderColor}` }}>
                            <div style={{ fontSize: "26px", fontWeight: "700", color: C.text, lineHeight: 1, letterSpacing: "-0.5px" }}>{value}</div>
                            <div style={{ fontSize: "11px", color: C.textMuted, marginTop: "5px", fontWeight: "500", textTransform: "uppercase", letterSpacing: "0.06em" }}>{label}</div>
                            {badge && <div style={{ display: "inline-block", marginTop: "8px", fontSize: "10px", padding: "2px 8px", borderRadius: "12px", background: C.success.bg, color: C.success.text, fontWeight: "600" }}>All generated</div>}
                        </div>
                    ))}
                </div> */}

                {/* Table card */}
                <div style={{ background: C.white, border: `1px solid ${C.border}`, borderRadius: "10px", overflow: "hidden", boxShadow: "0 1px 3px rgba(13,33,55,0.05)" }}>

                    {/* Toolbar */}
                    <div style={{ display: "flex", alignItems: "center", padding: "12px 16px", borderBottom: `1px solid ${C.border}`, background: C.white }}>
                        <div style={{ display: "flex", gap: "4px" }}>
                            {[
                                { key: "all", label: `All (${tdsReconHistoryData.length})` },
                                { key: "books", label: `Books (${booksCount})` },
                                { key: "gstr", label: `GSTR-2B (${gstrCount})` },
                            ].map(({ key, label }) => {
                                const active = activeFilter === key;
                                return (
                                    <button
                                        key={key}
                                        onClick={() => setActiveFilter(key)}
                                        style={{ padding: "5px 14px", borderRadius: "6px", border: `1px solid ${active ? C.navy : C.border}`, background: active ? C.navy : C.white, color: active ? C.white : C.textSub, fontSize: "12px", fontWeight: active ? "600" : "400", cursor: "pointer", transition: "all 0.15s" }}
                                    >
                                        {label}
                                    </button>
                                );
                            })}
                        </div>
                    </div>

                    {/* Scrollable table area */}
                    <div style={{ maxHeight: "480px", overflowY: "auto", overflowX: "hidden" }}>
                        <table style={{ width: "100%", borderCollapse: "collapse", tableLayout: "fixed" }}>
                            <colgroup>
                                <col style={{ width: "22%" }} />
                                <col style={{ width: "25%" }} />
                                <col style={{ width: "18%" }} />
                                <col style={{ width: "18%" }} />
                                <col style={{ width: "17%" }} />
                            </colgroup>
                            <thead style={{ position: "sticky", top: 0, zIndex: 1 }}>
                                <tr>
                                    <th style={thStyle}>Period</th>
                                    <th style={thStyle}>Run Date &amp; Time</th>
                                    <th style={thStyle}>Report Type</th>
                                    <th style={thStyle}>Status</th>
                                    <th style={{ ...thStyle, textAlign: "center" }}>Action</th>
                                </tr>
                            </thead>
                            <tbody>{renderTableBody()}</tbody>
                        </table>
                    </div>

                    {/* Footer */}
                    {!loaderForTable && filteredData.length > 0 && (
                        <div style={{ padding: "10px 18px", borderTop: `1px solid ${C.borderLight}`, fontSize: "11px", color: C.textMuted, background: C.white }}>
                            Showing {filteredData.length} of {tdsReconHistoryData.length} records
                        </div>
                    )}

                </div>{/* end Table card */}

            </div>{/* end page wrapper */}

            {/* Modal */}
            <Modal size="lg" centered show={showModal} onHide={handleCloseModal}>
                <Modal.Header closeButton style={{ background: C.navy, borderBottom: "none", padding: "16px 22px" }}>
                    <Modal.Title style={{ fontSize: "18px", fontWeight: "600", color: "#ffffff" }}>
                        Generate New ITC Report
                    </Modal.Title>
                </Modal.Header>

                <ValidatorForm useRef="form" onSubmit={onSubmitHandlerForData}>
                    <Modal.Body style={{ padding: "22px 22px 10px" }}>
                        <div style={{ marginBottom: "18px" }}>
                            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "24px" }}>
                                <div>
                                    <label style={{ fontSize: "12px", fontWeight: "600", color: C.textSub, marginBottom: "6px", display: "block", textTransform: "uppercase", letterSpacing: "0.05em" }}>
                                        From Month <span style={{ color: "#e53e3e" }}>*</span>
                                    </label>
                                    <MonthDatePicker
                                        placeholder="Month & Year"
                                        validators={["required"]}
                                        errorMessages={["This field is required"]}
                                        value={handleFromDateToDisplay}
                                        onChange={(v) => functionToHandleFromDate(v)}
                                    />
                                </div>
                                <div>
                                    <label style={{ fontSize: "12px", fontWeight: "600", color: C.textSub, marginBottom: "6px", display: "block", textTransform: "uppercase", letterSpacing: "0.05em" }}>
                                        To Month <span style={{ color: "#e53e3e" }}>*</span>
                                    </label>
                                    <MonthDatePicker
                                        placeholder="Month & Year"
                                        minDateForDatepicker={handleFromDateToDisplay}
                                        validators={["required"]}
                                        errorMessages={["This field is required"]}
                                        value={handleToDateToDisplay}
                                        onChange={(v) => functionToHandleToDate(v)}
                                    />
                                </div>
                            </div>
                        </div>

                        <div style={{ marginBottom: "18px" }}>
                            <label style={{ fontSize: "12px", fontWeight: "600", color: C.textSub, marginBottom: "6px", display: "block", textTransform: "uppercase", letterSpacing: "0.05em" }}>
                                Report Type <span style={{ color: "#e53e3e" }}>*</span>
                            </label>
                            <FormControl fullWidth variant="outlined" size="small">
                                <InputLabel>Select report type</InputLabel>
                                <Select
                                    value={selectedReportType}
                                    onChange={(e) => setSelectedReportType(e.target.value)}
                                    label="Select report type"
                                >
                                    <MenuItem value="books">Books</MenuItem>
                                    <MenuItem value="gstr_2b">GSTR-2B</MenuItem>
                                </Select>
                            </FormControl>
                        </div>
                    </Modal.Body>

                    <Modal.Footer style={{ padding: "12px 22px", gap: "8px", borderTop: `1px solid ${C.borderLight}` }}>
                        <button type="button" onClick={handleCloseModal} style={{ padding: "0 18px", height: "36px", borderRadius: "8px", border: `1px solid ${C.border}`, background: C.white, fontSize: "13px", color: C.textSub, cursor: "pointer" }}>
                            Cancel
                        </button>
                        <button type="submit" style={{ padding: "0 22px", height: "36px", borderRadius: "8px", background: C.navy, color: C.white, border: "none", fontSize: "13px", fontWeight: "600", cursor: "pointer" }}>
                            Generate Report
                        </button>
                    </Modal.Footer>
                </ValidatorForm>
            </Modal>

            {/* Snackbar */}
            <Snackbar
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
                open={snackbarOpen}
                autoHideDuration={5000}
                onClose={handleSnackbarClose}
                style={{ maxWidth: "340px" }}
            >
                <MuiAlert elevation={6} variant="filled" onClose={handleSnackbarClose} severity={snackbarSeverity}>
                    {responseMessage}
                </MuiAlert>
            </Snackbar>

        </React.Fragment>
    );
}